/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Information on the cancellation policy<br />
 * Current information at the time of booking.<br />
 * The calculate-cancellation-penalty method should be used to update the penalty information
 * @export
 * @interface TravelineCancellationPolicyDto
 */
export interface TravelineCancellationPolicyDto {
    /**
     * Is free cancellation possible
     * @type {boolean}
     * @memberof TravelineCancellationPolicyDto
     */
    freeCancellationPossible?: boolean;
    /**
     * Date and time up to and inclusive, when booking can be cancelled free of charge (no penalty).<br />
     * If ‘null’, see freeCancellationPossible.<br />
     * ‘null’ and freeCancellationPossible=true - free cancellation only<br />
     * ‘null’ and freeCancellationPossible=false - free cancellation is not possible<br /><br />
     * Local date and time for the hotel.<br />
     * Format complies with ISO-8601 YYYY-MM-DDThh:mm<br />
     * @type {Date}
     * @memberof TravelineCancellationPolicyDto
     */
    freeCancellationDeadlineLocal?: Date | null;
    /**
     * Same as freeCancellationDeadlineLocal, but date and time in UTC.<br />
     * Format complies with ISO-8601 YYYY-MM-DDThh:mmZ
     * @type {Date}
     * @memberof TravelineCancellationPolicyDto
     */
    freeCancellationDeadlineUtc?: Date | null;
    /**
     * Amount of the penalty for cancellation immediately after freeCancellationDeadline.<br />
     * For example, freeCancellationDeadline=2019-09-30T09:00Z, if cancelled on 2019-09-30T09:01Z, the penalty equals penaltyAmount.<br />
     * If freeCancellationDeadline=null, this amount of penalty if cancelled immediately after booking.<br />
     * null - always free cancellation.<br />
     * Depending on the date of cancellation, the amount of the penalty may vary in both directions.
     * @type {number}
     * @memberof TravelineCancellationPolicyDto
     */
    penaltyAmount?: number | null;
}

/**
 * Check if a given object implements the TravelineCancellationPolicyDto interface.
 */
export function instanceOfTravelineCancellationPolicyDto(value: object): value is TravelineCancellationPolicyDto {
    return true;
}

export function TravelineCancellationPolicyDtoFromJSON(json: any): TravelineCancellationPolicyDto {
    return TravelineCancellationPolicyDtoFromJSONTyped(json, false);
}

export function TravelineCancellationPolicyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineCancellationPolicyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'freeCancellationPossible': json['freeCancellationPossible'] == null ? undefined : json['freeCancellationPossible'],
        'freeCancellationDeadlineLocal': json['freeCancellationDeadlineLocal'] == null ? undefined : (new Date(json['freeCancellationDeadlineLocal'])),
        'freeCancellationDeadlineUtc': json['freeCancellationDeadlineUtc'] == null ? undefined : (new Date(json['freeCancellationDeadlineUtc'])),
        'penaltyAmount': json['penaltyAmount'] == null ? undefined : json['penaltyAmount'],
    };
}

  export function TravelineCancellationPolicyDtoToJSON(json: any): TravelineCancellationPolicyDto {
      return TravelineCancellationPolicyDtoToJSONTyped(json, false);
  }

  export function TravelineCancellationPolicyDtoToJSONTyped(value?: TravelineCancellationPolicyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'freeCancellationPossible': value['freeCancellationPossible'],
        'freeCancellationDeadlineLocal': value['freeCancellationDeadlineLocal'] == null ? undefined : ((value['freeCancellationDeadlineLocal'] as any).toISOString()),
        'freeCancellationDeadlineUtc': value['freeCancellationDeadlineUtc'] == null ? undefined : ((value['freeCancellationDeadlineUtc'] as any).toISOString()),
        'penaltyAmount': value['penaltyAmount'],
    };
}

